import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@mui/material";
import styles from "./styles.module.css";
import { useState } from "react";
import { BensAdiquiridoProduzido } from "../../../model/PrestacaoDeContas/RelacaoBens";
import { toIsoString } from "../../../controllers/Converters";
import Modal from "react-responsive-modal";
import ModalRelacaoBens from "../../../components/ModalForms/ModalRelacaoBens";

const RelacaoDeBens = () => {
  const [showAddRelacao, setAddRelacao] = useState(false);
  const [showEditRelacao, setEditRelacao] = useState(-1);
  const [bens, setBens] = useState<BensAdiquiridoProduzido[]>([
    {
      tipo: "NF",
      numero: "1",
      data: new Date(Date.now()),
      especificacaoBens: "Ração",
      quantidade: 4,
      valor: 50,
    },
  ]);
  return (
    <form className={styles.formCadastro} onSubmit={(e) => e.preventDefault()}>
      <div>
        <h2 className={styles.titulo}>
          5. Relação de Bens{" "}
          <strong>Adquiridos, Produzidos ou Construidos</strong>
        </h2>
        <div className={styles.table}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center" colSpan={3}>
                    DOCUMENTO
                  </TableCell>
                  <TableCell align="center" rowSpan={2}>
                    ESPECIFICAÇÃO DOS BENS
                  </TableCell>
                  <TableCell align="center" rowSpan={2}>
                    QTDE
                  </TableCell>
                  <TableCell align="center" colSpan={2}>
                    VALOR
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">TIPO</TableCell>
                  <TableCell align="center">N°</TableCell>
                  <TableCell align="center">DATA</TableCell>
                  <TableCell align="center">UNITÁRIO</TableCell>
                  <TableCell align="center">TOTAL</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bens.map((bem, index) => (
                  <>
                    <TableRow
                      hover
                      role="checkbox"
                      sx={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault();
                        setEditRelacao(index);
                      }}
                    >
                      <TableCell align="center">{bem.tipo}</TableCell>
                      <TableCell align="center">{bem.numero}</TableCell>
                      <TableCell align="center">
                        {toIsoString(bem.data)}
                      </TableCell>
                      <TableCell>{bem.especificacaoBens}</TableCell>
                      <TableCell align="center">{bem.quantidade}</TableCell>
                      <TableCell align="center">
                        R${bem.valor.toFixed(2)}
                      </TableCell>
                      <TableCell align="center">
                        R${(bem.quantidade * bem.valor).toFixed(2)}
                      </TableCell>
                    </TableRow>
                    <Modal
                      open={showEditRelacao === index}
                      onClose={() => {
                        setEditRelacao(-1);
                      }}
                      center
                      classNames={{
                        modal: "customModal",
                      }}
                    >
                      <ModalRelacaoBens
                        closeModal={() => setEditRelacao(-1)}
                        setList={setBens}
                        list={bens}
                        index={index}
                        refBem={bem}
                      />
                    </Modal>
                  </>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={6}>TOTAL</TableCell>
                  <TableCell align="center">
                    R$
                    {bens
                      .reduce(
                        (acc, current) =>
                          acc + current.valor * current.quantidade,
                        0
                      )
                      .toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>

          <div className={styles.addDiv}>
            <button
              className={styles.addBtn}
              onClick={(e) => {
                e.preventDefault();
                setAddRelacao(true);
              }}
            >
              + Adicionar Bem
            </button>
          </div>
          <Modal
            open={showAddRelacao}
            onClose={() => setAddRelacao(false)}
            center
            classNames={{
              modal: "customModal",
            }}
          >
            <ModalRelacaoBens
              closeModal={() => setAddRelacao(false)}
              setList={setBens}
              list={bens}
            />
          </Modal>
        </div>
      </div>
    </form>
  );
};

export default RelacaoDeBens;
